/**
 * @generated SignedSource<<1e315e74a7837621bc3b22a9ca4f065b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type GetBjfMiningHistoryFilter = {
  filterByFinished?: boolean | null;
  filterByPayedOut?: boolean | null;
  sortBy?: string | null;
  sortOrder?: string | null;
};
export type useBJFMiningHistoryQuery$variables = {
  page: number;
  pageSize?: number | null;
  filter?: GetBjfMiningHistoryFilter | null;
};
export type useBJFMiningHistoryQuery$data = {
  readonly getBjfMiningHistory: {
    readonly entries: ReadonlyArray<{
      readonly miningItemId: number;
      readonly miningAmount: number;
      readonly payedOut: string | null;
      readonly insertedAt: any;
      readonly updatedAt: any;
      readonly finished: boolean;
    }>;
    readonly pageNumber: number | null;
    readonly pageSize: number | null;
    readonly totalPages: number | null;
    readonly totalEntries: number | null;
  } | null;
};
export type useBJFMiningHistoryQuery = {
  variables: useBJFMiningHistoryQuery$variables;
  response: useBJFMiningHistoryQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "page"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageSize"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
      },
      {
        "kind": "Variable",
        "name": "page",
        "variableName": "page"
      },
      {
        "kind": "Variable",
        "name": "pageSize",
        "variableName": "pageSize"
      }
    ],
    "concreteType": "BjfMiningPaginatedPage",
    "kind": "LinkedField",
    "name": "getBjfMiningHistory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BjfMiningPaginated",
        "kind": "LinkedField",
        "name": "entries",
        "plural": true,
        "selections": [
          {
            "alias": "miningItemId",
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "miningAmount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "payedOut",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "insertedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "finished",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pageNumber",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pageSize",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalPages",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalEntries",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useBJFMiningHistoryQuery",
    "selections": (v3/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useBJFMiningHistoryQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "356b68e076f196cdafd9bc0bd8d90d02",
    "id": null,
    "metadata": {},
    "name": "useBJFMiningHistoryQuery",
    "operationKind": "query",
    "text": "query useBJFMiningHistoryQuery(\n  $page: Int!\n  $pageSize: Int\n  $filter: GetBjfMiningHistoryFilter\n) {\n  getBjfMiningHistory(page: $page, pageSize: $pageSize, filter: $filter) {\n    entries {\n      miningItemId: id\n      miningAmount\n      payedOut\n      insertedAt\n      updatedAt\n      finished\n    }\n    pageNumber\n    pageSize\n    totalPages\n    totalEntries\n  }\n}\n"
  }
};
})();

(node as any).hash = "c1592c43a1ad3e83243bc1511c80039f";

export default node;
